import Uuid7Generator from "./uuid7Generator";
export default () => Uuid7Generator.guid();
